module.exports = __webpack_public_path__ + "img/dapitana.6dd37253.png";